import * as React from 'react'
import { connect } from 'react-redux'

import { CommonState } from 'embed/reducers'
import { Field } from 'embed/constants'
import { summaryFieldsToDisplay } from 'embed/selectors/application'

import { ApplicationField, OwnProps as ApplicationFieldProps } from 'embed/components/ApplicationField/container'

interface Props extends ApplicationFieldProps {
  fieldsToDisplay: Field[]
}

// ApplicationFieldInline is an ApplicationField that is only displayed
// if the field isn't displayed in the summary card
const ApplicationFieldInline = ({ fieldsToDisplay, ...applicationFieldProps }: Props) =>
  !fieldsToDisplay.includes(applicationFieldProps.field) ? <ApplicationField {...applicationFieldProps} /> : null

const mapStateToProps = (state: CommonState) => ({
  fieldsToDisplay: summaryFieldsToDisplay(state),
})

export default connect(mapStateToProps)(ApplicationFieldInline)
